import React, { FunctionComponent } from "react";

import Check from "@uui/Check";

import styled from "@mui/material/styles/styled";

import Stack, { Row, StackProps } from "@rui/Stack";

export type StepState = "completed" | "current" | "pending";

type StepIconProps = { children: React.ReactNode; state: StepState };

export const StepIcon = styled<FunctionComponent<StepIconProps>>(
  ({ state: _, ...props }) => <Stack variant="center" {...props} />
)(({ state, theme }) => ({
  height: "24px",
  width: "24px",
  flexShrink: 0,
  borderRadius: "50%",
  color: "#FFF",
  fontSize: "0.75rem",
  backgroundColor:
    state === "completed"
      ? theme.palette.shades.meadow[500]
      : state === "current"
        ? theme.palette.shades.primary[500]
        : theme.palette.shades.neutral[500],
}));

type StepProps = StackProps & { state: StepState; index: number };

export const Step = styled<FunctionComponent<StepProps>>(
  ({ children, index, state, ...props }) => (
    <Row spacing={1} variant="left" {...props}>
      <StepIcon state={state}>
        {state === "completed" ? <Check /> : <>{index}</>}
      </StepIcon>
      {children}
    </Row>
  )
)(({ onClick, state, theme }) => ({
  fontSize: "0.875rem",
  fontWeight: 500,
  color:
    state === "pending"
      ? theme.palette.shades.neutral[500]
      : theme.palette.shades.neutral[800],
  "& .MuiSvgIcon-root": {
    fontSize: "16px",
  },
  "&:hover": {
    cursor: onClick ? "pointer" : "default",
  },
}));
